import React, { useEffect, useState } from 'react'; 
import { Image } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import Paginador, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { connect, useDispatch, useSelector } from 'react-redux';
import ColetaClickstream from '../../../components/clickstreamAnalise/clickstreamColeta.js';
import SpinerVeye from '../../../components/spinnerVeye/spinnerVeye.js';
import { api_gateway } from '../../../conexoes/api';
import '../../../css/painelAdministrativo/pavPerfil/pavPerfil.css';
import { desabilitarAcoes, limpadorFiltros, limpouBusca, mudarFiltros, mudarManejador, realizouBusca, realizouFiltro, revelarBarraFiltragem, revelarExcluirPerfil } from "../../../redux/actions/index";
import { elipseVerde, elipseVermelho } from '../../../utils/alternanciaIcones';
import PaginacaoTabela from '../../../utils/paginacaoTabela';
import BarraDadosCliente from '../../componentesModais/barraDadosCliente/barraDadosCliente';
import BarraFiltragem from '../../componentesModais/barraFiltragem/barraFiltragem';
import MensagemConfirmarExclusao from '../../componentesModais/mensagens/mensagemConfirmarExclusao';
import MensagemErro from '../../componentesModais/mensagens/mensagemErro';
import MensagemSucesso from '../../componentesModais/mensagens/mensagemSucesso';
import CadastroPerfil from './cadastro';

let contador = 0
let controladorPagina = 1
let totalPaginas = 0
let totalItens = 0
const valorLimite = 50

function PavPerfil(){
    // SPINNER
    const [spinAtivo, setSpinAtivo] = useState(true);
    //HOOKS TABELA
    const [itens, setItens] = useState([]);
    const [paginaAtual, setPaginaAtual] = useState(1);
    const [renderizar, setRenderizar] = useState(false);
    //HOOKS VARIÁVEIS
    const [cdPerfil, setCdPerfil] = useState("");
    const [dsPerfil, setDsPerfil] = useState("");
    const [dsDescricao, setDsDescricao] = useState("");

    const [flVirtueyes, setFlVirtueyes] = useState(0);
    const [flAtivo, setFlAtivo] = useState(0);
    const [flAtribuivel, setFlAtribuivel] = useState(0);
    const [flCustomizado, setFlCustomizado] = useState(0);
    const [n0_precedencia, setN0_precedencia] = useState(0);
    const [cd_pav_cliente, setCd_pav_cliente] = useState(0);
    const [ds_pav_cliente, setDs_pav_cliente] = useState('');
    const [isSelect, setIsSelect] = useState(false);
    //HOOKS MENSAGENS
    const [revelarMensagemAtencao, setRevelarMensagemAtencao] = useState(false)
    const [revelarMensagemErro, setRevelarMensagemErro] = useState(false)
    const [revelarMensagemSucesso, setRevelarMensagemSucesso] = useState(false)
    const [mensagemErro, setMensagemErro] = useState("Ocorreu um erro ao executar esta ação");
    //HOOKS MODAL
    // const [renderizarCadastro, setRenderizarCadastro] = useState(false)
    // const [renderizarEdicao, setRenderizarEdicao] = useState(false)
    const [revelarCadastro, setRevelarCadastro] = useState(false)
    const [revelarEdicao, setRevelarEdicao] = useState(false)
    //HOOKS REDUX
    const despacho = useDispatch();
    let conteudoBusca = useSelector(state => state.manejadorState.conteudoBusca);
    let limpouBuscaGeral = useSelector(state => state.manejadorState.limpouBusca);
    let realizouBuscaGeral = useSelector(state => state.manejadorState.realizouBusca);
    let filtros = useSelector(state => state.filtrosState.filtros);
    let revelarBarraFiltro = useSelector(state => state.filtrosState.revelarBarraFiltragem);
    let realizouFiltragem = useSelector(state => state.manejadorState.realizouFiltro);
    let novoPerfil = useSelector(state => state.manejadorState.revelarNovoPerfil);
    let editarPerfil = useSelector(state => state.manejadorState.revelarEditarPerfil);
    let excluirPerfil = useSelector(state => state.manejadorState.revelarExcluirPerfil);
    let temFiltros = false;

    let itensVar = []
    // USABILIDADE
    const [coletaUsabilidade, setColetaUsabilidade] = useState(true)

    useEffect(() => {
        if(coletaUsabilidade) {
            ColetaClickstream(128) // 'pavPerfilTabelaGrid'
            setColetaUsabilidade(false)
        }
    },[])

    useEffect(() => {
        function checarFiltros() {
            if (filtros.vazio === 'vazio') {
                temFiltros = false;
            } else {
                temFiltros = true;
            }
        }
        checarFiltros();
    }, [filtros]);

    useEffect(()=>{
        despacho(revelarBarraFiltragem(false))
        if(!filtros.vazio){
            despacho(mudarFiltros({vazio: 'vazio'}))
        }        
        despacho(limpadorFiltros(true))
    }, [])

    useEffect(() => {
        setSpinAtivo(true)
        despacho(mudarManejador("perfil"))
        despacho(desabilitarAcoes(true))
        async function carregarTabela(){

             //clicou no botão de limpar a busca geral e retorna tudo ao estado original
             if(limpouBuscaGeral){
                despacho(limpouBusca(false));
                restaurarConfigsIniciaisPagina()
            }

            //clicou no botão de busca geral
            if(realizouBuscaGeral){
                despacho(realizouBusca(false));
                restaurarConfigsIniciaisPagina()
            }    

            //clicou no botão para filtro
            if(realizouFiltragem){
                despacho(realizouFiltro(false));
                restaurarConfigsIniciaisPagina()
            }

            if(conteudoBusca  && filtros.vazio){
                if(totalPaginas == 0){
                    contador = 0;
                    itensVar = [];
                    setItens([])
                    await contarItens();
                }
                else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                if (controladorPagina <= paginaAtual) {
                    await contarItens();
                    const { data } = await api_gateway.get('/m1/consultar/perfil?paginaAtual='+contador+'&carregarLimit='+valorLimite+'&buscar='+conteudoBusca);
                    inserirData(data.dados)
                }
            }else if(!filtros.vazio){
                if(totalPaginas == 0){
                    contador = 0;
                    itensVar = [];
                    setItens([])
                    await contarItens();
                }else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                const dados = {
                    paguinaAtual: contador,
                    carregarLimit: valorLimite,
                    buscar:conteudoBusca,
                    filtros: filtros
                }
                if (controladorPagina <= paginaAtual) {
                    const { data } = await api_gateway.post("/m1/filtrar/perfil", dados);
                    inserirData(data.dados)
                }
            }else{
                if(totalPaginas == 0){
                    await contarItens();
                }else{
                    contador = (paginaAtual - 1) * valorLimite;
                }
                if (controladorPagina <= paginaAtual) {
                    const { data } = await api_gateway.get('/m1/consultar/perfil?paginaAtual='+contador+'&carregarLimit='+valorLimite);
                    inserirData(data.dados)
                }
            }
            setSpinAtivo(false)
        }
        carregarTabela();
    }, [paginaAtual, conteudoBusca, renderizar, filtros])

  
    function inserirData(data){
        for(let i=0;i<totalItens;i++){
            if (contador === i){
                let k = i
                for(let j=0;j<data.length;j++){
                    itensVar[k] = data[j]
                    k++
                }
            }
            if(i == (totalItens-1)){
                setItens(JSON.parse(JSON.stringify(itensVar)))
            }
        }
    }
  
   
    async function contarItens(){
        let arrayItens = []
        let apiData = []
        if (controladorPagina <= paginaAtual) { 
            if (controladorPagina <= paginaAtual && filtros.vazio) { 
                apiData = await api_gateway.get('/m1/consultar/perfil?contar="true"&buscar='+conteudoBusca);
            }else{
                const dados = {
                    paguinaAtual: contador,
                    carregarLimit: valorLimite,
                    buscar:conteudoBusca,
                    filtros: filtros,
                    contar: true
                }
                apiData = await api_gateway.post("/m1/filtrar/perfil", dados);
            }
            if(apiData.data.dados){
                totalPaginas = Math.ceil(apiData.data.dados[0].CONTADOR / valorLimite)
                totalItens = apiData.data.dados[0].CONTADOR;
                for( var i = 0 ; i < apiData.data.dados[0].CONTADOR; i++){
                    arrayItens.push(i)
                }
                itensVar = arrayItens
            }
        }
    }

    function restaurarConfigsIniciaisPagina(){
        totalPaginas = 0
        contador = 0
        controladorPagina = 1
        totalItens = 0
        setPaginaAtual(1)
    }

    const colunas = [{
        dataField: 'cd_pav_perfil',
        text: 'ID',
        sort: true,
        headerClasses: 'tabela-coluna-primeira-header nao-selecionavel',
        headerStyle: () => {
            return { width: '130px'}
        },
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
    },
    {
        dataField: 'ds_pav_perfil',
        headerClasses: 'nao-selecionavel',
        text: 'Nome do perfil',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
    },
    {
        dataField: 'ds_descricao',
        headerClasses: 'nao-selecionavel',
        text: 'Descrição do perfil',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell}</p>;
        }
    },
    {
        dataField: 'fl_virtueyes',
        headerClasses: 'nao-selecionavel',
        text: 'Perfil virtueyes',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell || cell == 0 ? 
                    cell == 1 ?
                        <>
                        <Image className="img-eclipse-status" src={elipseVerde()}/>
                        Sim
                        </>
                    :
                    <>
                        <Image className="img-eclipse-status" src={elipseVermelho()}/>
                        Não
                    </> 
                :''}
            </p>;
        }
    },
    {
        dataField: 'fl_atribuivel',
        headerClasses: 'nao-selecionavel',
        text: 'Atribuível',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell || cell == 0 ? 
                    cell == 1 ?
                        <>
                        <Image className="img-eclipse-status" src={elipseVerde()}/>
                        Sim
                        </>
                    :
                    <>
                        <Image className="img-eclipse-status" src={elipseVermelho()}/>
                        Não
                    </> 
                :''}
            </p>;
        }
    },
    {
        dataField: 'fl_customizado',
        headerClasses: 'nao-selecionavel',
        text: 'Customizado',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell || cell == 0 ? 
                    cell == 1 ?
                        <>
                        <Image className="img-eclipse-status" src={elipseVerde()}/>
                        Sim
                        </>
                    :
                    <>
                        <Image className="img-eclipse-status" src={elipseVermelho()}/>
                        Não
                    </> 
                :''}
            </p>;
        }
    },
    {
        dataField: 'n0_precedencia',
        headerClasses: 'nao-selecionavel',
        text: 'Precedência',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell && cell !== null ? cell :''}</p>;
        }
    },
    {
        dataField: 'n0_codigo_cliente',
        headerClasses: 'nao-selecionavel',
        text: 'Cliente',
        sort: true,
        formatter: (cell) => {
            return <p className="fonte-cor-1 label-tabela-1">{cell && cell !== null ?cell:''}</p>;
        }
    }]

    const selecaoLinhas = {
        mode: 'radio',
        onSelect: (row, isSelect) => {
            setIsSelect(isSelect)
            if(isSelect){
                setCdPerfil(row.cd_pav_perfil);
                setDsPerfil(row.ds_pav_perfil);
                setDsDescricao(row.ds_descricao);
                setFlVirtueyes(row.fl_virtueyes);
                setFlAtivo(row.bl_pav_ativo);
                setFlAtribuivel(row.fl_atribuivel);
                setFlCustomizado(row.fl_customizado);
                setN0_precedencia(row.n0_precedencia);
                setCd_pav_cliente(row.cd_pav_cliente);
                setDs_pav_cliente(row.ds_pav_cliente);
                despacho(desabilitarAcoes(false));
            }
        },
        selectionRenderer: ({ mode}) => {
            return (
                <label className="label-checkbox-cliente-virtueyes fonte-cor-1">
                    <input type={mode} id=" CLIENTEVEYE" name="CLIENTE"/>
                    <span className="checkbox-cliente-virtueyes radio-button-cor-1" />
                </label>
            )
        }
    };

  
    const opcoesPaginacao = {
        page: paginaAtual,
        showTotal: true,
        sizePerPage: valorLimite,
        firstPageTitle: 'Primeira',
        lastPageTitle: 'Última',
        nextPageTitle: 'Proxima',
        prePageTitle: 'Anterior',
        custom: true,
        onPageChange:(page) => {setPaginaAtual(page)}
    }

 
    async function handleDeletar(){
        ColetaClickstream(1452) // PainelAdmPerfilDropAcoesExcluir
        setSpinAtivo(true)
        await api_gateway.get('/m1/deletar/perfil?cd_pav_perfil='+cdPerfil)
            .then(function () {
                handleMensagemSucesso(false)
                despacho(revelarExcluirPerfil(false))
                setRenderizar(!renderizar)
                setSpinAtivo(false)
            })
            .catch(function (error) {
                despacho(revelarExcluirPerfil(false))
                setMensagemErro(error.response.data.info)
                handleMensagemErro(false)
                setSpinAtivo(false)
            })
    }

    // function handleCadastrar(){
    //     setRevelarCadastro(true)
    //     setRenderizarCadastro(!renderizarCadastro)
    // }
    
    // function handleEditar(){
    //     setRevelarEdicao(true)
    //     setRenderizarEdicao(!renderizarEdicao)
    // }

    // function handleCancelar(){
    //     setRevelarMensagemAtencao(false)
    //     setRevelarMensagemErro(false)
    //     setRevelarMensagemSucesso(false)
    //     setRevelarCadastro(false)
    //     setRevelarEdicao(false)
    // }

    function handleMensagemAtencao(confirmacao){
        if(revelarMensagemAtencao === false){
            setRevelarMensagemAtencao(true)
        }else{
            setRevelarMensagemAtencao(false)
            if(confirmacao === true){
                handleDeletar()
            }
        }
    }

    function handleMensagemErro(confirmacao){
        if(revelarMensagemErro === false){
            setRevelarMensagemErro(true)
        }else{
            setRevelarMensagemErro(false)
            if(confirmacao === true){
                //ALGUMA FUNÇÃO
            }
        }
    }

    function handleMensagemSucesso(confirmacao){
        if(revelarMensagemSucesso === false){
            setRevelarMensagemSucesso(true)
        }else{
            setRevelarMensagemSucesso(false)
            if(confirmacao === true){
                //ALGUMA FUNÇÃO
            }
        }
    }

    return(
        <>
            <BarraDadosCliente/>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }
            { novoPerfil === true &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <CadastroPerfil
                            tituloJanela="Cadastrar"
                            setRevelarCadastro={setRevelarCadastro}
                            setRevelarEdicao={setRevelarEdicao}
                            renderizar={renderizar}
                            setRenderizar={setRenderizar}
                         />
                    </div>
                </div>
            }
            { editarPerfil === true &&
                <div className="componente-modal-overlay">
                    <div className="componente-modal">
                        <CadastroPerfil
                            tituloJanela="Editar"
                            cdPerfil={cdPerfil}
                            dsPerfil={dsPerfil}
                            dsDescricao={dsDescricao}
                            setRevelarCadastro={setRevelarCadastro}
                            setRevelarEdicao={setRevelarEdicao}
                            renderizar={renderizar}
                            setRenderizar={setRenderizar}
                            flVirtueyes={flVirtueyes}
                            flAtivo={flAtivo}
                            flAtribuivel={flAtribuivel}
                            flCustomizado={flCustomizado}
                            n0_precedencia={n0_precedencia}
                            cd_pav_cliente={cd_pav_cliente}
                            ds_pav_cliente={ds_pav_cliente}
                             />
                    </div>
                </div>
            }
            { revelarBarraFiltro === true &&
                <BarraFiltragem/>
            }
            <PaginationProvider pagination={Paginador(opcoesPaginacao)} >
                {
                    ({
                        paginationProps,
                        paginationTableProps
                    }) => (
                        <>
                            <BootstrapTable
                                hover
                                condensed
                                keyField='cd_pav_perfil' 
                                data={itens} 
                                columns={colunas} 
                                selectRow={ selecaoLinhas }
                                bootstrap4
                                bordered={false}
                                classes="tabela"
                                noDataIndication={!spinAtivo && "Nenhum item encontrado"}
                                { ...paginationTableProps }
                            />
                            <PaginacaoTabela
                                setPaginaAtual={setPaginaAtual}
                                totalPaginas={totalPaginas}
                                totalItens={totalItens}
                                valorLimite={valorLimite}
                                paginaAtual={paginaAtual}
                                page={paginationProps.page}
                                onPageChange={paginationProps.onPageChange}
                            />
                        </>
                    )
                }
            </PaginationProvider>
            <div className="itens-exibidos-tabela fonte-cor-1">
                Mostrando 
                <span className="label-tabela-itens-exibidos">{contador + 1}</span>
                    - 
                <span className="label-tabela-itens-exibidos">{ contador + valorLimite <= totalItens ? contador + valorLimite : totalItens }</span>
                    de 
                <span className="label-tabela-itens-exibidos">{totalItens}</span>
            </div>
            { revelarMensagemSucesso &&
                <MensagemSucesso
                    handleMensagemSucesso={handleMensagemSucesso}
                    mensagemTitulo="Sucesso"
                    mensagemParagrafo1={"Perfil "+ dsPerfil +" deletado."}
                    mensagemBotao="Continuar"
                />
            }
            { excluirPerfil &&
                <MensagemConfirmarExclusao
                    handleMensagemAtencao={handleMensagemAtencao}
                    mensagemTitulo={"Deletar "+dsPerfil}
                />
            }
            { revelarMensagemErro &&
                <MensagemErro
                    handleMensagemErro={handleMensagemErro}
                    mensagemTitulo={mensagemErro}
                    mensagemParagrafo1="Erro"
                    mensagemParagrafo2={mensagemErro}
                    mensagemBotao="Retornar"
                />
            }
        </>
    )
}

function mapStateToProps(state) {
    return { conteudoBusca: state.manejadorState.conteudoBusca, filtros: state.filtrosState.filtros };
} 
//React.memo - nao permitir a renderizacao se o state e o props nao mudarem de estado
export default connect(mapStateToProps)(React.memo(PavPerfil));